<sharry-generic-dialog
  [disabled]="step === 'option' ? !selectedOption : !text.length"
  [footerStandardButtonLabel]="step === 'option' ? 'report-dialog.next' : null"
  [footerType]="step !== 'confirmation' ? 'standard' : 'none'"
  [header]="{ type: 'onlyTitle', title: title | i18next }"
  [hideBackIcon]="step !== 'text'"
  (back)="backStep()"
  (cancel)="close()"
  (confirm)="nextStep()">
  @if (busy) {
    <sharry-loading></sharry-loading>
  }
  @if (!busy) {
    <div class="report-dialog">
      @if (step === 'confirmation') {
        <img
          alt="bullet"
          src="https://media.sharry.land/app/images/ic-list-bullet.webp" />
      }
      @if (step === 'confirmation') {
        <h3>{{ confirmationTitle | i18next }}</h3>
      }
      @if (step !== 'confirmation') {
        <div class="report-dialog__body">
          @if (step === 'option') {
            <mat-radio-group [(ngModel)]="selectedOption">
              @for (option of options; track option) {
                <mat-radio-button
                  color="primary"
                  [value]="option"
                  >{{ 'report-dialog.' + option | i18next }}
                </mat-radio-button>
              }
            </mat-radio-group>
          }
          @if (step === 'text') {
            <div class="report-dialog__selected-option">
              <p class="bigger">{{ 'report-dialog.' + selectedOption | i18next }}</p>
            </div>
            @if (showBlock) {
              <mat-checkbox
                color="primary"
                class="report-dialog__checkbox"
                [(ngModel)]="blockContent"
                >{{ 'report-dialog.hide-content' | i18next }}
              </mat-checkbox>
            }
            <mat-form-field appearance="outline">
              <textarea
                matInput
                rows="5"
                [placeholder]="'report-dialog.placeholder' | i18next"
                [(ngModel)]="text"></textarea>
            </mat-form-field>
          }
        </div>
      }
      @if (step === 'confirmation') {
        <div class="report-dialog__body report-dialog__body--confirmation">
          <p
            class="report-dialog__confirmation-text bigger"
            [innerHTML]="confirmationTextTop | i18next"></p>
          <p
            class="report-dialog__confirmation-text bigger"
            [innerHTML]="confirmationTextBottom | i18next"></p>
        </div>
      }
    </div>
  }
</sharry-generic-dialog>
